module.exports = __webpack_public_path__ + "static/media/pdf.fe1d72b8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/pdf.svg
// module id = 1362
// module chunks = 0